// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__pbPl8","Cards-wrapper":"Cards_Cards-wrapper__ozGHx","card":"Cards_card__me72Y","icon-wrapper":"Cards_icon-wrapper__sOF0x"};